import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Administrator } from "../models/administrator";
import NavBarLoggedInView from "./NavBarLoggedInView";
import NavBarLoggedOutView from "./NavBarLoggedOutView";

interface NavBarProps {
    loggedInUser: Administrator | null
    onLogoutSuccessful: () => void,
}

const NavBar = ({loggedInUser, onLogoutSuccessful}: NavBarProps) => {
    return (
        <Navbar bg="primary" variant="dark" expand="md">
            <Container>
                <Navbar.Brand as={Link} to="/">
                    Dream Manage
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="main-navbar" />
                <Navbar.Collapse id="main-navbar">
                    <Nav className="ms-auto">
                            { loggedInUser
                                ? <NavBarLoggedInView user={loggedInUser} onLogoutSuccessful={onLogoutSuccessful} />
                                : <NavBarLoggedOutView/>
                            }
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavBar;